import React, { useEffect, useState } from 'react';
import styles from './InitialNode.module.scss';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import InitialModal from './initialModal/InitialModal';
import NodeContainer from '../node-container/NodeContainer';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';

const InitialNode = ({ id, data, selected, ...props }) => {
  const { workflowData } = useWorkflowContext();
  const { isSystem, systemName } = workflowData;
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error);

  const handleInitialNodeClick = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (node?.createWorkFlow_Intents) {
      if (!node?.createWorkFlow_Intents?.name) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error);
    }
  }, [node?.createWorkFlow_Intents, node?.createWorkFlow_Intents?.name]);
 
  return (
    <>
      <NodeContainer
        initial
        backgroundColor={node?.color ?? page_ButtonColor}
        id={id}
        onClick={handleInitialNodeClick}
        selected={selected}
        isError={isError}
      >
        <div className={styles.initial}>
          <SvgWithBranding type="flag" />
          <p>
            {isSystem
              ? workflowData?.systemName
              : node?.createWorkFlow_Intents?.name !== undefined
              ? node?.createWorkFlow_Intents?.name || 'Start'
              : 'Start'}
          </p>
        </div>

        <Handle
          id={id}
          nodeid={id}
          type="source"
          position={Position.Right}
          className="custom-handle"
        />
      </NodeContainer>

      <InitialModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={id}
        isError={isError}
        isSystem={isSystem}
      />
    </>
  );
};

export default InitialNode;
